import { CountryCode } from '~/enums';
import { homePageByMarket } from '~/constants/markets';
import { Language } from '~/store/types/sharedTypes';

export const openQredCardGeneralTermsPage = (
  market: CountryCode,
  language: Language
) => {
  switch (market.toUpperCase()) {
    case CountryCode.FI:
      window.open(
        `${homePageByMarket[market][language]}/info/luottokortti-ehdot`,
        'generalTerms',
        'noopener'
      );
      break;
    case CountryCode.SE: {
      const url =
        language === Language.English
          ? 'https://www.qred.se/en/info/terms-company-credit-card'
          : 'https://www.qred.se/info/villkor-foretagskreditkort';
      window.open(url, 'generalTerms', 'noopener');
      break;
    }
    case CountryCode.NL:
      window.open(
        `${homePageByMarket[market][language]}/info/algemene-voorwaarden-qeld-visa`,
        'generalTerms',
        'noopener'
      );
      break;
    default:
      console.error(`Unsupported market ${market} when opening card prices`);
      break;
  }
};

export const openQredCardBusinessTermsPage = (
  market: CountryCode,
  language: Language
) => {
  switch (market.toUpperCase()) {
    case CountryCode.SE: {
      const url =
        language === Language.English
          ? 'https://www.qred.se/en/info/terms-business-products'
          : 'https://www.qred.se/info/allmanna-villkor-foretagsprodukter';
      window.open(url, 'businessTerms', 'noopener');
      break;
    }
    default:
      console.error(
        `Unsupported market ${market} when opening card business terms`
      );
      break;
  }
};

export const openQredCardPricesPage = (
  market: CountryCode,
  language: Language
) => {
  switch (market.toUpperCase()) {
    case CountryCode.FI:
      window.open(
        `${homePageByMarket[market][language]}/luottokortti-hinnasto`,
        'cardPrices',
        'noopener'
      );
      break;
    case CountryCode.SE:
      window.open(
        `${homePageByMarket[market][language]}/kort-prislista`,
        'cardPrices',
        'noopener'
      );
      break;
    case CountryCode.NL:
      window.open(
        `${homePageByMarket[market][language]}/zakelijke-creditcard/prijslijst-qeld-visa`,
        'cardPrices',
        'noopener'
      );
      break;
    default:
      console.error(`Unsupported market ${market} when opening card prices`);
      break;
  }
};

export const openQredHomePage = (market: CountryCode, language: Language) => {
  const url = homePageByMarket[market][language];
  window.open(
    url,
    market === CountryCode.NL ? 'qeldHome' : 'qredHome',
    'noopener'
  );
};

export const openAppStore = (language: Language) => {
  switch (language) {
    case Language.Swedish:
      window.open(
        'https://apps.apple.com/se/app/qred/id1528985194',
        'appStore',
        'noopener'
      );
      break;
    case Language.Finnish:
      window.open(
        'https://apps.apple.com/se/app/qred/id1528985194?l=fi',
        'appStore',
        'noopener'
      );
      break;
    default:
      window.open(
        'https://apps.apple.com/se/app/qred/id1528985194?l=en',
        'appStore',
        'noopener'
      );
      break;
  }
};

export const openGooglePlay = () => {
  window.open(
    'https://play.google.com/store/apps/details?id=com.qred',
    'googlePlay',
    'noopener'
  );
};
